var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "74.271362mm",
    height: "74.27137mm",
    viewBox: "0 0 74.271362 74.27137",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-64.705611,-133.3325)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path111-0-7",
    style: {
      fill: "#686868",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 21.1402,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 124.11343,200.08922 c 16.30727,-12.35248 19.51327,-35.58581 7.16079,-51.89309 l -16.87254,12.78065 c 5.29393,6.98883 3.91993,16.94597 -3.06891,22.23989 -6.98885,5.29393 -16.94598,3.91993 -22.239901,-3.06891 -5.29392,-6.98883 -3.919928,-16.94597 3.068919,-22.2399 L 79.381131,141.03532 c -16.307297,12.35249 -19.51328,35.58581 -7.160797,51.89309 6.176238,8.15364 15.072693,13.03197 24.463492,14.32781 9.390804,1.29586 19.275964,-0.99076 27.429604,-7.167 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect14568-4",
    style: {
      fill: "#72a7b6",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 32.7709,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 76.277994,186.4372 64.705611,207.60387 H 81.582166 L 93.155039,186.4372 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect17587",
    style: {
      fill: "#686868",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 76.0857,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 135.93692,190.71394 a 39.687506,39.687496 0 0 1 -19.94245,16.88993 h 22.79447 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path111-0-8",
    style: {
      fill: "#595959",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 21.1402,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 101.74728,133.52263 c -20.457552,0 -37.041669,16.58412 -37.041668,37.04167 h 21.166666 c 0,-8.76752 7.10748,-15.875 15.875002,-15.875 8.76752,0 15.875,7.10748 15.875,15.875 0,8.76752 -7.10748,15.875 -15.875,15.875 v 21.16668 c 20.45755,0 37.04166,-16.58413 37.04166,-37.04168 0,-10.22877 -4.14603,-19.48919 -10.84925,-26.19241 -6.70322,-6.70323 -15.96364,-10.84926 -26.19241,-10.84926 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20671-5-2-8",
    style: {
      fill: "#72a7b6",
      fillOpacity: 1,
      strokeWidth: 58.8285,
      strokeLinejoin: "bevel"
    },
    d: "m 138.97697,151.85334 c 0,10.22877 -8.29206,18.52082 -18.52083,18.52082 -10.22877,0 -18.52084,-8.29205 -18.52084,-18.52082 0,-10.22878 8.29206,-18.52084 18.52084,-18.52084 5.11439,0 9.7446,2.073 13.09622,5.42464 3.35161,3.35161 5.42462,7.98182 5.42461,13.0962 z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceLogo);
export default __webpack_public_path__ + "static/media/service_logo.066d22bbedd41fc9c2894e27f2c9eb88.svg";
export { ForwardRef as ReactComponent };